import axios from "axios";

export default {
  getAll() {
    let tokenAuth = localStorage.getItem("access_token");
    let headerAuth = { headers: { Authorization: `${tokenAuth}` } };

    return axios
      .get("api/marcasproducto", headerAuth)
      .then((result) => {
        return result.data;
      })
      .catch((e) => {
        console.log(e);
        throw e;
      });
  },

  get(id) {
    let tokenAuth = localStorage.getItem("access_token");
    let headerAuth = { headers: { Authorization: `${tokenAuth}` } };

    return axios
      .get(`api/marcaproducto/${id}`, headerAuth)
      .then((result) => {
        return result.data;
      })
      .catch((e) => {
        console.log(e);
        throw e;
      });
  },

  add(marcaProducto) {
    let tokenAuth = localStorage.getItem("access_token");
    let headerAuth = { headers: { Authorization: `${tokenAuth}` } };

    return axios
      .post("api/marcaproducto", marcaProducto, headerAuth)
      .then((result) => {
        return result.data;
      })
      .catch((e) => {
        console.log(e);
        throw e;
      });
  },

  update(marcaProducto) {
    let tokenAuth = localStorage.getItem("access_token");
    let headerAuth = { headers: { Authorization: `${tokenAuth}` } };

    return axios
      .put(
        `api/marcaproducto/${marcaProducto.marcaId}`,
        marcaProducto,
        headerAuth
      )
      .then((result) => {
        return result.data;
      })
      .catch((e) => {
        console.log(e);
        throw e;
      });
  },

  delete(id) {
    let tokenAuth = localStorage.getItem("access_token");
    let headerAuth = { headers: { Authorization: `${tokenAuth}` } };

    return axios
      .delete(`api/marcaproducto/${id}`, headerAuth)
      .then((result) => {
        return result.data;
      })
      .catch((e) => {
        console.log(e);
        throw e;
      });
  },
};
